webpackJsonp([25],{

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'app',
	components: {}
};

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _util = __webpack_require__(30);

exports.default = {
	data: function data() {
		return {
			collapsed: false,
			sysUserName: '',
			sysUserAvatar: '',
			form: {
				name: '',
				region: '',
				date1: '',
				date2: '',
				delivery: false,
				type: [],
				resource: '',
				desc: ''
			},
			menusPath: []
		};
	},

	methods: {
		onSubmit: function onSubmit() {},
		handleopen: function handleopen() {},
		handleclose: function handleclose() {},

		handleselect: function handleselect(a, b) {
			console.log(a, b);
		},

		logout: function logout() {
			var _this = this;
			this.$confirm('确认退出吗?', '提示', {}).then(function () {
				(0, _util.removeLocalStorage)('user');
				(0, _util.removeCookie)('token');
				_this.$router.push('/login');
			}).catch(function () {});
		},

		collapse: function collapse() {
			this.collapsed = !this.collapsed;
		},
		showMenu: function showMenu(i, status) {
			this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
		},
		getAllPath: function getAllPath() {
			var _this2 = this;

			var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

			return arr.map(function (val) {
				if (val.menuModelList && val.menuModelList.length) {
					_this2.getAllPath(val.menuModelList);
				}
				_this2.menusPath.push(val.page);
			});
		}
	},
	mounted: function mounted() {
		var user = (0, _util.getLocalStorage)('user');
		if (user) {
			user = JSON.parse(user);
			this.sysUserName = user.companyName || '';
			this.sysUserAvatar = user.companyLogo || 'https://1stand-hz.oss-cn-hangzhou.aliyuncs.com//one-www/photo/20190516/1557976316588.png';
		}
		this.getAllPath(user.list);
	}
};

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(84);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(32);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(81);

__webpack_require__(83);

var _store = __webpack_require__(80);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(53);

var _vuex2 = _interopRequireDefault(_vuex);

var _router = __webpack_require__(57);

var _router2 = _interopRequireDefault(_router);

var _index = __webpack_require__(78);

var _index2 = _interopRequireDefault(_index);

var _loading = __webpack_require__(79);

var load = _interopRequireWildcard(_loading);

var _util = __webpack_require__(30);

__webpack_require__(82);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_elementUi2.default);
_vue2.default.use(_vuex2.default);

_vue2.default.prototype.$load = load;

for (var key in _index2.default) {
  _vue2.default.filter(key, _index2.default[key]);
}

_router2.default.beforeEach(function (to, from, next) {
  if (to.path == '/login') {
    sessionStorage.removeItem('user');
  }
  var token = (0, _util.getCookie)('token');
  if (token === '' && to.path != '/login') {
    next({ path: '/login' });
  } else {
    next();
  }
});

new _vue2.default({
  router: _router2.default,
  store: _store2.default,

  render: function render(h) {
    return h(_App2.default);
  }
}).$mount('#app');

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Home = __webpack_require__(179);

var _Home2 = _interopRequireDefault(_Home);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
    path: '/login',
    component: function component() {
        return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 188));
    },
    name: '',
    hidden: true
}, {
    path: '/404',
    component: function component() {
        return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 187));
    },
    name: '',
    hidden: true
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-tv',
    leaf: true,
    children: [{ path: '/index', component: function component() {
            return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 201));
        }, name: '工作台' }],
    redirect: { path: '/index' }
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-user-circle',
    leaf: true,
    children: [{ path: '/customerManage', component: function component() {
            return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 200));
        }, name: '用户管理' }, { path: '/cardPage', component: function component() {
            return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 193));
        }, name: '名片详情', hidden: true }]
}, {
    path: '/',
    component: _Home2.default,
    name: '企业管理',
    iconCls: 'fa fa-address-card',
    children: [{ path: '/companyManage', component: function component() {
            return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 196));
        }, name: '企业管理' }, { path: '/companyOemManage', component: function component() {
            return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 198));
        }, name: 'OEM管理' }, { path: '/companyCardPage', component: function component() {
            return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 195));
        }, name: '企业详情', hidden: true }, { path: '/companyVideo', component: function component() {
            return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 199));
        }, name: '企业功能管理' }, { path: '/modelSwitch', component: function component() {
            return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 202));
        }, name: '模块管理' }, { path: '/permissionsManage', component: function component() {
            return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 204));
        }, name: '权限管理' }, { path: '/operationRecords', component: function component() {
            return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 203));
        }, name: '操作记录' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '企业服务',
    iconCls: 'fa fa-file-text',
    children: [{ path: '/activity', component: function component() {
            return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 192));
        }, name: '活动管理' }, { path: '/publishActivity', component: function component() {
            return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 93));
        }, name: '发布活动', hidden: true }, { path: '/editActivity', component: function component() {
            return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 93));
        }, name: '编辑活动', hidden: true }, { path: '/buyActivity', component: function component() {
            return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 191));
        }, name: '购买详情', hidden: true }, { path: '/serviceOrder', component: function component() {
            return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 206));
        }, name: '订单管理' }, { path: '/orderDetail', component: function component() {
            return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 205));
        }, name: '订单详情' }]
}, {
    path: '/data',
    component: _Home2.default,
    name: '数据中心',
    iconCls: 'fa fa-bar-chart',
    children: [{ path: '/data/yimaiSmartCard', component: function component() {
            return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 190));
        }, name: '瑞银尊享名片' }, { path: '/data/yimaiCrmCard', component: function component() {
            return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 189));
        }, name: '瑞银尊享CRM' }, { path: '/data/visitorData', component: function component() {
            return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 208));
        }, name: '访客数据' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '小程序管理',
    iconCls: 'fa fa-file-text',
    children: [{ path: '/codeManage', component: function component() {
            return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 194));
        }, name: '代码管理' }, { path: '/versionManage', component: function component() {
            return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 207));
        }, name: '小程序版本管理' }, { path: '/wxappletManage', component: function component() {
            return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 209));
        }, name: '小程序管理' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-envelope-o',
    leaf: true,
    children: [{ path: '/companyNotice', component: function component() {
            return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 197));
        }, name: '更新公告' }],
    redirect: { path: '/index' }
}, {
    path: '*',
    hidden: true,
    redirect: { path: '/404' }
}];

exports.default = routes;

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var increment = exports.increment = function increment(_ref) {
    var commit = _ref.commit;

    commit('INCREMENT');
};
var decrement = exports.decrement = function decrement(_ref2) {
    var commit = _ref2.commit;

    commit('DECREMENT');
};

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getCount = exports.getCount = function getCount(state) {
    return state.count;
};

/***/ }),

/***/ 168:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 169:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 178:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAADZUlEQVRIS8WWSWgUURCG/+pJjIoXo9GToChuiEtvoyLiigTRmY5bvAgKCi4giojLJYIbqCCIHgT1piZouhMSEQVXxGRed4+iqOACKoqKy0EPMcl0SXdMnEw6yUxU5p26X1X936tX1a8fIU+D8sRF/sBxVySJmQAJgAcwsf/IDAbw2FK0NX3ZlbgjrhMwC4EUPEKg5794JKGVDNduAnNRd+IM7LMUrSIXuOGI/QD2dhtD9LNXcFuwN99UojeygcdcsUBiXO/RN3swfWqJFMh1U6e+60kw9igxQmqmJIAh/wgc1CZh1dXPQEWFFyrKTHHXvk9AtNedyT7jNikGjluKti1M2LDFMRC29wr1HXIFB3DCckvWLqcD4kIsIwmXsoL2FQzg+7fiH8NujZrb1LYNTEbS/gxG8f8G+6wxlqq+9EGlrlvSn1OfsoZmlTHRRjBvBTC+k3CK55i6ftufM9zGKWDpQbqdgTcg7CLG+dAF9VrjiDeuySv8VsSttwg0sUOEsNqUtYv+e1yIUpJwJQ3wVvIwx+vX7wdamz/4rdQF3iOY8NWsrS/xP5/Fd+8OLhzYv4qABcFxAuytUbSDAdgRWwg48Vv8KVGktFqWXwc2W7wiwqjcwOAbpqLPbw9awRxpSdorKYVCBp5ZmpYItvqhmIRmyIHfIK/enBD90h4Td8QlApblCMYRU9F25tQ0Gc6Ga+8C86GcwAQur1b0yr8Bx5zGRRKkqzmBJalg7OVp056nB8UcsUci6GGLYdATS1b3pNtK3TslRTzgI2U2WLfNxfzVVLShIAr+oe3DcOzTAK8PB6PSUrTyTJvhiBcARnea76Grb5qKNi9E5ACATlm1+zDzKUvVN3eJsRPVIDKyAjPzMUvVd2SKlNn2JiY+GVp35t2mqh/OtAXlAfwF/xndZczgVZaiV3VZvRDlkHAhDOyB19Uo+rkuMUmxEB6uZQdOO4s71ViIhZAyRDocvCWmEq3LBIee5eEZ02tTUUeGZVVm2zITO6EZM02vUdXGMJvhiIcAJnfYfHDcTrQQUUFaAUxTUcvCBJY2NAyPFEbOtN0X02sGpCiyoVaW34eDE2cBWtthY05RLJEYAaIoEWaDMJOYL5qqfjS0gfo4GXfEBmJsBOEemG57nteQvwt9H5P467C8ZfwL2B62hylNzCQAAAAASUVORK5CYII="

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(169)

var Component = __webpack_require__(55)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(181),
  /* scopeId */
  "data-v-59f748be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 180:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "logo-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(178),
      "alt": ""
    }
  }), _vm._v(" "), (!_vm.collapsed) ? _c('h1', [_vm._v("瑞银尊享总后台")]) : _vm._e()])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "tools",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.collapse.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  })])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('img', {
    attrs: {
      "src": this.sysUserAvatar
    }
  }), _vm._v(" " + _vm._s(_vm.sysUserName))]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [_c('el-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? [(!item.leaf && (item.path == '/' || _vm.menusPath.includes(item.path))) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden && _vm.menusPath.includes(child.path)) ? _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0 && _vm.menusPath.includes(item.children[0].path)) ? _c('el-menu-item', {
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.children[0].name))]) : _vm._e()] : _vm._e()
  })], 2), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapsed),
      expression: "collapsed"
    }],
    ref: "menuCollapsed",
    staticClass: "el-menu el-menu-vertical-demo collapsed"
  }, _vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? _c('li', {
      key: index,
      staticClass: "el-submenu item"
    }, [(!item.leaf) ? [_c('div', {
      staticClass: "el-submenu__title",
      staticStyle: {
        "padding-left": "20px"
      },
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })]), _vm._v(" "), _c('ul', {
      staticClass: "el-menu submenu",
      class: 'submenu-hook-' + index,
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('li', {
        key: child.path,
        staticClass: "el-menu-item",
        class: _vm.$route.path == child.path ? 'is-active' : '',
        staticStyle: {
          "padding-left": "40px"
        },
        on: {
          "click": function($event) {
            return _vm.$router.push(child.path)
          }
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    }), 0)] : [_c('li', {
      staticClass: "el-submenu"
    }, [_c('div', {
      staticClass: "el-submenu__title el-menu-item",
      class: _vm.$route.path == item.children[0].path ? 'is-active' : '',
      staticStyle: {
        "padding-left": "20px",
        "height": "56px",
        "line-height": "56px",
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push(item.children[0].path)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })])])]], 2) : _vm._e()
  }), 0)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$route.name))]), _vm._v(" "), _c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t")])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function setCookie(name, value, day) {
  var oDate = new Date();
  oDate.setDate(oDate.getDate() + day);
  if (day) {
    document.cookie = name + '=' + value + ';expires=' + oDate;
  } else {
    document.cookie = name + '=' + value;
  }
}

function getCookie(name) {
  var arr = document.cookie.split('; ');
  for (var i = 0; i < arr.length; i++) {
    var arr2 = arr[i].split('=');
    if (arr2[0] === name) {
      return arr2[1];
    }
  }
  return '';
}

function removeCookie(name) {
  setCookie(name, 1, -1);
}

var setLocalStorage = exports.setLocalStorage = function setLocalStorage(name, value) {
  localStorage.setItem(name, value);
};
var getLocalStorage = exports.getLocalStorage = function getLocalStorage(name) {
  return localStorage.getItem(name);
};
var removeLocalStorage = exports.removeLocalStorage = function removeLocalStorage(name) {
  return localStorage.removeItem(name);
};

function str2date(str) {
  var d = new Date(str);
  var time = d.getFullYear() + "-" + (d.getMonth() + 1).toString().padStart(2, '0') + "-" + d.getDate().toString().padStart(2, '0');
  return time;
}

function str2time(str) {
  var d = new Date(str);
  var time = d.getFullYear() + "-" + (d.getMonth() + 1).toString().padStart(2, '0') + "-" + d.getDate().toString().padStart(2, '0') + " " + d.getHours().toString().padStart(2, '0') + ":" + d.getMinutes().toString().padStart(2, '0') + ":" + d.getSeconds().toString().padStart(2, '0');
  return time;
}

function sortByCreateTime(a, b) {
  return b.createTime - a.createTime;
}

exports.setCookie = setCookie;
exports.getCookie = getCookie;
exports.removeCookie = removeCookie;
exports.str2date = str2date;
exports.str2time = str2time;
exports.sortByCreateTime = sortByCreateTime;

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(182);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _routes = __webpack_require__(119);

var _routes2 = _interopRequireDefault(_routes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
    routes: _routes2.default
});

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function formatDate(str) {
    if (!str || str == '') {
        return '';
    }
    var d = new Date(str);
    var time = d.getFullYear() + "-" + (d.getMonth() + 1).toString().padStart(2, '0') + "-" + d.getDate().toString().padStart(2, '0');
    return time;
}

function formatDateTime(str) {
    if (!str || str == '') {
        return '';
    }
    var d = new Date(str);
    var time = d.getFullYear() + "-" + (d.getMonth() + 1).toString().padStart(2, '0') + "-" + d.getDate().toString().padStart(2, '0') + " " + d.getHours().toString().padStart(2, '0') + ":" + d.getMinutes().toString().padStart(2, '0') + ":" + d.getSeconds().toString().padStart(2, '0');
    return time;
}

function formatDateMin(str) {
    if (!str || str == '') {
        return '';
    }
    var d = new Date(str);
    var time = d.getFullYear() + "-" + (d.getMonth() + 1).toString().padStart(2, '0') + "-" + d.getDate().toString().padStart(2, '0') + " " + d.getHours().toString().padStart(2, '0') + ":" + d.getMinutes().toString().padStart(2, '0');
    return time;
}

function getStatus(companyCard) {
    if (companyCard.endTime) {
        var endTime = new Date(companyCard.endTime).getTime();
        var nowTime = new Date().getTime();
        if (endTime > nowTime) {
            return "";
        } else {
            return "已到期";
        }
    } else {
        return "未授权";
    }
}

function timestampToMin(timestamp) {
    var time = Number(String(timestamp * 1000).slice(0, 13));
    return formatDateMin(new Date(time));
}

function getStatusByTimestamp(timestamp) {
    var nowTime = new Date().getTime();
    if (timestamp > nowTime) {
        return "已授权";
    } else {
        return "已到期";
    }
}

function getState(state) {
    if (typeof state == 'undefined') {
        return '暂无';
    }
    var status = {
        '-1': '提交失败',
        1: '提交成功',
        2: '审核中',
        3: '审核提交失败',
        4: '审核失败',
        5: '审核成功',
        6: '发布成功',
        7: '发布失败'
    };
    return status[state];
}

exports.default = { formatDate: formatDate, formatDateTime: formatDateTime, formatDateMin: formatDateMin, getStatus: getStatus, timestampToMin: timestampToMin, getStatusByTimestamp: getStatusByTimestamp, getState: getState };

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideLoad = exports.showLoad = undefined;

var _elementUi = __webpack_require__(32);

var loading = void 0;

function showLoad() {
  loading = _elementUi.Loading.service({
    lock: true,
    text: '加载中……'
  });
}

function hideLoad() {
  loading.close();
}

exports.showLoad = showLoad;
exports.hideLoad = hideLoad;

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(53);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(120);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(121);

var getters = _interopRequireWildcard(_getters);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
    count: 10
};

var mutations = {
    INCREMENT: function INCREMENT(state) {
        state.count++;
    },
    DECREMENT: function DECREMENT(state) {
        state.count--;
    }
};

exports.default = new _vuex2.default.Store({
    actions: actions,
    getters: getters,
    state: state,
    mutations: mutations
});

/***/ }),

/***/ 81:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 82:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 83:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(168)

var Component = __webpack_require__(55)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(180),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ })

},[118]);


// WEBPACK FOOTER //
// static/js/app.f7e478a3a9d3fca43260.js